import createCache from '@emotion/cache';

function getNonce() {
  if (typeof document === 'undefined') {
    return process.env.CSP_NONCE;
  }

  const nonceCarrier = document.querySelector('style[nonce], script[nonce]');
  const tagNonce = nonceCarrier?.nonce || nonceCarrier?.getAttribute('nonce');

  if (tagNonce) {
    return tagNonce;
  }

  const policy = document
    .querySelector('meta[http-equiv="Content-Security-Policy"]')
    ?.getAttribute('content');

  return policy?.match(/'nonce-([^']+)'/)?.[1];
}

export default function createEmotionCache() {
  return createCache({
    key: 'css',
    nonce: getNonce(),
  });
}
